import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { TravelSearchToggles } from '@shared/store/models/travel-search-toggles';
import { TRAVEL_SEARCH_TOGGLES_LOCAL_STORAGE_KEY } from 'app.config';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import * as fromTravelSearchTogglesActions from '../actions/travel-search-toggles.actions';
import { getTravelSearchTogglesFeatureState } from '../selectors';

@Injectable()
export class TravelSearchTogglesEffects implements OnInitEffects {
  constructor(private actions$: Actions, private store: Store) {}

  public ngrxOnInitEffects(): Action {
    return new fromTravelSearchTogglesActions.RestoreTravelSearchToggles();
  }

  public restoreTravelSearchToggles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTravelSearchTogglesActions.RESTORE_TRAVEL_SEARCH_TOGGLES),
      map(() => this.getLocalStorage()),
      filter((localStorageItem) => !!localStorageItem),
      map((localStorageItem) => new fromTravelSearchTogglesActions.UpdateTravelSearchToggles(localStorageItem))
    )
  );

  public clearTravelSearchToggles$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTravelSearchTogglesActions.CLEAR_TRAVEL_SEARCH_TOGGLES),
        tap(() => this.clearLocalStorage())
      ),
    { dispatch: false }
  );

  public updateTravelSearchToggles$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTravelSearchTogglesActions.UPDATE_TRAVEL_SEARCH_TOGGLES),
        switchMap(() => this.store.select(getTravelSearchTogglesFeatureState)),
        tap((toggles) => this.setLocalStorage(toggles))
      ),
    { dispatch: false }
  );

  /**
   * Sets the local storage item for the travel booking progress bar
   * If there is already data stored locally add it to the object so it's not lost
   *
   * @param data
   */
  public setLocalStorage(data: TravelSearchToggles) {
    localStorage.setItem(TRAVEL_SEARCH_TOGGLES_LOCAL_STORAGE_KEY, JSON.stringify(data));
  }

  public getLocalStorage(): TravelSearchToggles {
    const item = localStorage.getItem(TRAVEL_SEARCH_TOGGLES_LOCAL_STORAGE_KEY);
    return item ? JSON.parse(item) : null;
  }

  private clearLocalStorage() {
    localStorage.removeItem(TRAVEL_SEARCH_TOGGLES_LOCAL_STORAGE_KEY);
  }
}
